import {ToastActions} from "../constants/toastActions";
export const toast =  (title, show , callback) => dispatch => {

            dispatch({
                type: ToastActions.SHOW,
                payload: {
                    // TODO
                    title: title,
                    show: show
                }
            });
            callback()
        }




// WEBPACK FOOTER //
// ./src/actions/toastAction.tsx